import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReportStateContext } from '../../context/ReportStateContext';

export const useReportState = () => {
  const navigate = useNavigate();
  const {
    state,
    setTaskId,
    setTaskStatus,
    setReports,
    setAnalyticsData,
    setCurrentStep,
    setIsLoading,
    setError,
    setSelectedReportIndices,
    updateAnalyticsState,
    resetState
  } = useReportStateContext();

  const navigateToStep = useCallback((step: string) => {
    console.log('navigateToStep - переход на шаг:', step);
    const targetUrl = `/create-report/${step}`;
    console.log('navigateToStep - целевой URL:', targetUrl);
    // Используем navigate вместо window.location.href, чтобы избежать перезагрузки страницы
    navigate(targetUrl);
  }, [navigate]);

  return {
    state,
    setTaskId,
    setTaskStatus,
    setReports,
    setAnalyticsData,
    setCurrentStep,
    setIsLoading,
    setError,
    setSelectedReportIndices,
    updateAnalyticsState,
    resetState,
    navigateToStep
  };
};
